document.addEventListener('DOMContentLoaded', function () {
	// nav get expandables
	const navItems = [...document.getElementsByClassName('n-exp')];
	// click item
	navItems.forEach( link => {
		link.addEventListener('click', function(e) {
			const this_item = e.target;
			const this_level_items = [...this_item.parentElement.parentElement.children];
			this_level_items.forEach( item => {
				let href = item.querySelector('a');
				if (href && !href.isEqualNode(this_item)) {
					if (href.nextElementSibling) {
						href.nextElementSibling.setAttribute('aria-hidden', true);
					}
					href.classList.remove('open');
				}
				// console.log(item, href);
			});
			// console.log(this_item, this_item.nextElementSibling);
			this_item.classList.toggle('open');
			// if ul content exists
			if (this_item.nextElementSibling) { // && this_item.nextElementSibling.getAttribute('aria-hidden')
				// dropdown opened
				this_item.nextElementSibling.toggleAttribute('aria-hidden');

				if (this_item.classList.contains('open')) { //  ||
					// console.log(this_item.nextElementSibling, event.currentTarget, this_item.nextElementSibling.getAttribute('aria-hidden'), this_item.classList.contains('open'));
					e.preventDefault();
				}
			}

		})
	});

	// mobile burger
	const nav = document.getElementById('nv');
	const burger_icon = document.getElementById('burgericon');
	const burger = document.getElementById('burger');
	// eslint-disable-next-line no-unused-vars

	if (burger) {
		burger.addEventListener('click', () => {
			burger_icon.classList.toggle('open');
			nav.classList.toggle('open');
		});
	}

	// click outside goals
	const navigation_d1 = [...document.getElementsByClassName('l1')];
	const navigation_d2 = [...document.getElementsByClassName('l2')];

	document.addEventListener('click', event => {
		// const isClickInside = specifiedElement.contains(event.target)

		let isClickBurger = false;
		if (burger && burger.contains(event.target)) {
			isClickBurger = true;
		}

		let isClickInside = false;
		navigation_d1.every( dd => {
			if (dd.contains(event.target)) {
				isClickInside = true;
				return false;
			}
			return true;
		});

		navigation_d2.every( dd => {
			if (dd.contains(event.target)) {
				isClickInside = true;
				return false;
			}
			return true;
		});

		// close by outside click
		if (!isClickInside && window.innerWidth >= 992) {
			navigation_d2.forEach( dd => {
				let link = dd.parentElement.firstElementChild;
				// console.log( link );
				dd.setAttribute('aria-hidden', false);
				link.classList.remove('open');
			});
			if (!isClickBurger) {
				burger_icon.classList.remove('open');
				nav.classList.remove('open');
				// console.log('clicked outside burger');
			} else {
				// console.log('clicked inside burger');
			}
			// console.log('clicked outside');
		} else {
			// console.log('clicked inside');
		}

	});
});
